import { AUTHORING_CONTENT_TYPES } from '../../../constants/comman';
import contentSubtypeServices from '../services/contentSubtypeServices';

import { ContentSubtypeAction } from '../types/ContentSubtypeAction';
import ContentSubtypeData from '../types/ContentSubtypeData';
import * as libraryActions from '../actions/actionType';

const list = () => (dispatch: any) => {
  const success = (data: ContentSubtypeData[]): ContentSubtypeAction =>
    ({ type: 'CONTENT_SUBTYPE_SUCCESS', data });
  const failure = (error: string): ContentSubtypeAction =>
    ({ type: 'CONTENT_SUBTYPE_FAILED', error });

  contentSubtypeServices.list()
    .then(
      res => { dispatch(success(res)) },
      err => { dispatch(failure(err)) }
    );
}

const contentSubtypeByContentTypeCode = (code: string, templateType?: string, ignoreEmptyRules?: boolean) => (dispatch: any) => {
  const success = (data: ContentSubtypeData[]): ContentSubtypeAction => {
    if (code == "question") {
      return { type: 'CONTENT_SUBTYPE_QUESTION_SUCCESS', data }
    }
    else if (code == "studymaterial") {
      return { type: 'CONTENT_SUBTYPE_STUDYMATERIAL_SUCCESS', data }
    }
    else if (code === "practiceSet") {
      return { type: 'CONTENT_SUBTYPE_PRACTICESET_SUCCESS', data }
  } else if (code === "ftreQuestion") {
      return { type: libraryActions.CONTENT_SUBTYPE_FTRE_QUESTION_SUCCESS, data }
  } else if (code === AUTHORING_CONTENT_TYPES.FTRE_TESTPAPERS) {
    return { type: libraryActions.CONTENT_SUBTYPE_FTRE_TESTPAPERS_SUCCESS, data }
  } else if (code === AUTHORING_CONTENT_TYPES.AITS_QUESTION) {
    return { type: libraryActions.CONTENT_SUBTYPE_AITS_QUESTION_SUCCESS, data }
  } else if (code === AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS) {
    return { type: libraryActions.CONTENT_SUBTYPE_AITS_TESTPAPERS_SUCCESS, data }
  } else if (code === AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION) {
    return { type: libraryActions.CONTENT_SUBTYPE_NATIONAL_LEVET_QUESTION_SUCCESS, data }
  } else if (code === AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS) {
    return { type: libraryActions.CONTENT_SUBTYPE_NATIONAL_LEVEL_TESTPAPERS_SUCCESS, data }
  } else {
    return { type: 'CONTENT_SUBTYPE_TEST_SUCCESS', data }
  }
  };
  const failure = (error: string): ContentSubtypeAction =>
    ({ type: 'CONTENT_SUBTYPE_FAILED', error });

  contentSubtypeServices.listByContentTypeCode(code, templateType, ignoreEmptyRules)
    .then(
      res => { dispatch(success(res)) },
      err => { dispatch(failure(err)) }
    );
}

const contentSubtypeActions = {
  list,
  contentSubtypeByContentTypeCode
};

export default contentSubtypeActions;
